

class ProductFormFabricTabsDress {
  constructor() {
    this.handleClick = this.handleClick.bind(this);
    document.addEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const button = event.target.closest('[data-fabric-option]');
    if (!button) return;

    const container = button.closest('[data-product-form-selectors]');
    if (!container) return;

    const handle = button.dataset.fabricHandle;

    container
      .querySelectorAll('[data-fabric-option]')
      .forEach((el) => {
        const active = el === button;
        el.classList.toggle(
          'product-fabric-option--selected',
          active,
        );
        el.setAttribute('aria-selected', String(active));
      });

    container
      .querySelectorAll('[data-fabric-panel]')
      .forEach((panel) => {
        panel.hidden = panel.dataset.fabricHandle !== handle;
      });

    const label = container.querySelector(
      '[data-fabric-selected-value]',
    );
    if (label) label.textContent = button.textContent.trim();

    const guideTemplate = container.querySelector(
      'template[data-guide-content]',
    );

    if (guideTemplate) {
      guideTemplate.content
        .querySelectorAll('[data-guide-tab]')
        .forEach((tab) => {
          const matches = tab.dataset.fabricValue === handle;
          tab.classList.toggle('is-active', matches);
          tab.setAttribute('aria-selected', String(matches));
        });

      guideTemplate.content
        .querySelectorAll('[data-guide-panel]')
        .forEach((panel) => {
          const matches = panel.dataset.fabricValue === handle;
          panel.classList.toggle('is-active', matches);
          panel.hidden = !matches;
        });
    }

    this.activateColorForFabric(container, handle);
  }

  activateColorForFabric(container, fabricHandle) {

    const currentColor = container
      .querySelector('[data-product-swatch-link][aria-current="page"]')
      ?.getAttribute('title');

    const panel = container.querySelector(
      `[data-fabric-panel][data-fabric-handle="${fabricHandle}"]`,
    );

    if (!panel) return;

    const matchingLink = currentColor
      ? panel.querySelector(
          `[data-product-swatch-link][title="${CSS.escape(currentColor)}"]`,
        )
      : null;

    const targetLink =
      matchingLink || panel.querySelector('[data-product-swatch-link]');

    if (!targetLink || targetLink.getAttribute('aria-current') === 'page') {
      return;
    }

    targetLink.click();
  }
}

window.ProductFormFabricTabsDress = ProductFormFabricTabsDress;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductFormFabricTabsDress();
  });
} else {
  new ProductFormFabricTabsDress();
}
